import { useIntl } from '@/intl'
import { memo, useState } from 'react'

function RawMixValue() {
  const texts = useTexts()
  return texts.mix
}

export const MixValue = memo(RawMixValue)

function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mix: translate({ id: 'global.mix' }),
  }))

  return api
}
